import React from 'react';

const VINTAGE_BEIGE = "#e5d1a5"; 
const JERUSALEM_GOLD = "#c5a059"; 

const Codex = ({ player, setPlayer }) => {
  return (
    <div style={{ 
      minHeight: '80vh', 
      display: 'flex', 
      flexDirection: 'column', 
      padding: '40px',
      backgroundColor: 'var(--sidebar-bg)', // Espresso Koyu Tema
      border: `1px solid ${JERUSALEM_GOLD}`,
      boxShadow: 'inset 0 0 50px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.3)',
      borderRadius: '2px' // Keskin Hatlar
    }}>
      
{/* --- ASİL BAŞLIK BÖLÜMÜ (CODEX) --- */}
      <div style={{ 
        borderBottom: `1px solid ${JERUSALEM_GOLD}`, 
        paddingBottom: '12px', // Biraz daralttık (kompaktlık)
        marginBottom: '30px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-end' 
      }}>
        <div>
          <h2 style={{ 
            fontFamily: 'Cinzel, serif', 
            color: JERUSALEM_GOLD, 
            margin: 0, 
            fontSize: '1.6rem', // 2rem'den 1.6rem'e çekildi (Profesyonel seviye)
            letterSpacing: '2px', 
            textTransform: 'uppercase', 
            textShadow: '1px 1px 3px rgba(0,0,0,0.8)' 
          }}>
            The Codex
          </h2>
          <p style={{ 
            fontFamily: 'Courier Prime, monospace', 
            color: VINTAGE_BEIGE, 
            opacity: 0.6, // Biraz daha geri plana ittik ki başlık parlasın
            fontSize: '0.85rem', // Yazıyı da küçülttük
            margin: '5px 0 0 0', 
            letterSpacing: '0.5px' 
          }}>
            Record your core principles, undeniable truths, and system architecture.
          </p>
        </div>
      </div>

      {/* --- YAZI ALANI (KARANLIK BÜYÜLÜ DEFTER EFEKTİ) --- */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(0, 0, 0, 0.3)', // Yazı alanını bir tık daha karanlık yaparak derinlik katıyoruz
        border: `1px solid ${JERUSALEM_GOLD}`,
        borderTop: '4px solid var(--accent-red)', // Kartlardaki asil bordo tepe çizgisi
        borderRadius: '2px',
        padding: '25px',
        boxShadow: 'inset 0 0 20px rgba(0,0,0,0.5)'
      }}>
        <textarea 
          className="vintage-input"
          value={player.notes || ""} 
          onChange={e => setPlayer({...player, notes: e.target.value})} 
          placeholder="Document your philosophy here..."
          spellCheck="false" 
          style={{
            flex: 1,
            width: '100%',
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
            resize: 'none', 
            color: '#fdfbf7', // Yazılar fildişi/parşömen beyazı
            fontFamily: 'Courier Prime, monospace',
            fontSize: '1.1rem',
            lineHeight: '35px',
            padding: '0 5px',
            // Altın yaldızlı çok ince satır çizgileri:
            backgroundImage: `repeating-linear-gradient(transparent, transparent 34px, rgba(197, 160, 89, 0.15) 34px, rgba(197, 160, 89, 0.15) 35px)`,
            backgroundAttachment: 'local'
          }}
        />
      </div>
      
    </div>
  );
};

export default Codex;